import { createSelector } from 'viewup-lib/common';
import type { StoreApi, UseBoundStore } from 'zustand';
import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
import type { RateLimitOverlayStoreProps } from './useRateLimitOverlayStore.types';

export const useRateLimitOverlayStoreBase = create<RateLimitOverlayStoreProps>()(
  immer((set, _get) => ({
    actions: {
      trigger: (resetAt: number) => {
        set((prev) => {
          if (prev.resetAt === null || resetAt > prev.resetAt) {
            prev.resetAt = resetAt;
          }
        });
      },
      reload: () => {
        if (typeof window !== 'undefined') {
          window.location.reload();
        }
      },
    },
    resetAt: null,
  })),
) as UseBoundStore<StoreApi<RateLimitOverlayStoreProps>>;

export const useRateLimitOverlayStore = createSelector<
  RateLimitOverlayStoreProps,
  typeof useRateLimitOverlayStoreBase
>(useRateLimitOverlayStoreBase);
